// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3494c1cf","732":"8b93364a","977":"8e3987ac"}[chunkId] + ".chunk.js";
};